import { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';

// Data the prerender step (scripts/prerender.mjs) baked into the page, so the
// first client render shows exactly what the static HTML showed.
export const InitialDataContext = createContext({});

export const normalizePath = (path) => (path || '/').replace(/\/+$/, '') || '/';

// Reads <script id="__INITIAL_DATA__"> once. The inline guard in the prerendered
// HTML removes it when the URL is not the route it was rendered for.
export const readInitialData = () => {
  if (typeof document === 'undefined') return {};
  try {
    const el = document.getElementById('__INITIAL_DATA__');
    return el ? JSON.parse(el.textContent) : {};
  } catch {
    return {};
  }
};

// The embedded data, but only while we are still on the route it was rendered for.
export const useInitialData = () => {
  const data = useContext(InitialDataContext);
  const { pathname } = useLocation();
  return data.route && data.route === normalizePath(pathname) ? data : {};
};
